export default __webpack_public_path__ + "maps-examples-line-gradient-1200-c284e98edcdb062cb4c960491384e0c0.png";